import React, { Component } from 'react';

class FilterClient extends Component {
    
    render(){

        // const { affiliateData,formErrors, locations} = this.props; 

        return(
            <React.Fragment>
                <div className="filter-category">
                <h4>Roles</h4>
                <div className="form-group">
                <div className="form-group select-input">
                    <select>
                        <option>All Roles</option>
                        <option>Option 1</option>
                        <option>Option 2</option>
                        <option>Option 3</option>
                        <option>Option 4</option>
                    </select>
                </div>
                </div>
            </div>
            <div className="filter-category">
                <h4>Status</h4>
                <div className="form-group">
                <div className="form-group select-input">
                    <select>
                        <option>Select Status</option>
                        <option>Option 1</option>
                        <option>Option 2</option>
                        <option>Option 3</option>
                        <option>Option 4</option>
                    </select>
                </div>
                </div>
            </div>
            
            
            
        </React.Fragment>
        )
    }

}
export default FilterClient;